import axios from "../auth/FetchInterceptor";

export const getAllClients = async (page = 1, limit = 10) => {
  const response = await axios.get(`/renter?page=${page}&limit=${limit}`);
  return response;
};

export const createClient = async (data) => {
  const response = await axios.post("/renter", data);
  return response.data;
};

export const updateClient = async (id, data) => {
  const response = await axios.put(`/renter/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteClient = async (id) => {
  const response = await axios.delete(`/renter/${id}`);
  return response.data;
};
